function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import Button from "segments/desktop/core-components/button/button";
import Title from "segments/desktop/core-components/title/title";
import { StyledTimerVerticalTabsMobileComponent } from "./timer-verticals-tabs-mobile-component.scss";
import VerticalTimerTabMobileComponent from "./vertical-timer-tab-mobile/vertical-timer-tab-mobile-component";
class TimerVerticalTabsMobileComponent extends PureComponent {
    render() {
        const { showButton, buttonConfig, tabsTitle } = this.props;
        return /*#__PURE__*/ _jsxs(StyledTimerVerticalTabsMobileComponent, {
            className: "mobile-timer-tabs-component",
            children: [
                tabsTitle && /*#__PURE__*/ _jsx("div", {
                    className: "mobile-tabs-title-wrapper",
                    children: /*#__PURE__*/ _jsx(Title, _object_spread({}, tabsTitle))
                }),
                this.renderTabs(),
                showButton && /*#__PURE__*/ _jsx("div", {
                    className: "mobile-button-link",
                    children: /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig))
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "setSelectedTab", (newSelectedTab)=>{
            const { timerEnabled } = this.props;
            this.setState((prevState)=>({
                    selectedTab: !timerEnabled && prevState.selectedTab === newSelectedTab ? null : newSelectedTab
                }));
        });
        _define_property(this, "renderTabs", ()=>{
            const { selectedTab } = this.state;
            const { tabs, tabContentRenderer, assetQuality, title, showArrow, progressbarColor, rightSideRenderer, alwaysShowProgressbar, arrowSize, backgroundColor, tabTitleRenderer, getTabIdentifier } = this.props;
            const { fontSize, selectedFontSize, fontColor, selectedFontColor, fontWeight } = title || {};
            return tabs.map((tab, index)=>{
                return /*#__PURE__*/ _jsx(VerticalTimerTabMobileComponent, _object_spread_props(_object_spread({
                    index: index
                }, tab), {
                    getTabIdentifier: getTabIdentifier,
                    isSelected: index === selectedTab,
                    setSelectedTab: this.setSelectedTab,
                    assetQuality: assetQuality,
                    rightSideRenderer: rightSideRenderer,
                    showArrow: showArrow,
                    tabContentRenderer: tabContentRenderer,
                    fontSize: fontSize,
                    tabTitleRenderer: tabTitleRenderer,
                    selectedFontSize: selectedFontSize,
                    fontColor: fontColor,
                    selectedFontColor: selectedFontColor,
                    titleFontWeight: fontWeight,
                    progressbarColor: progressbarColor,
                    alwaysShowProgressbar: alwaysShowProgressbar,
                    arrowSize: arrowSize,
                    backgroundColor: backgroundColor
                }), index);
            });
        });
        this.state = {
            selectedTab: 0
        };
    }
}
export { TimerVerticalTabsMobileComponent as default };
